// extracted by mini-css-extract-plugin
module.exports = {"scrollIcon":"TabScrollIcon_scrollIcon__TqBqc"};